import React, { Dispatch, SetStateAction } from 'react'
import { PermissionDto } from 'api/Identity/Types/PermissionDto'
import { SignInResponse } from 'api/Identity/Types/SignInResponse'

import { DepartmentType } from '../api/Identity/Types/DepartmentType'

export interface AuthSession {
  user: SignInResponse
  permissions: PermissionDto[]
}

export type MaybeAuthSession = AuthSession | null
export type AuthSessionContextType = [MaybeAuthSession, Dispatch<SetStateAction<MaybeAuthSession>>]

export const AuthSessionContext = React.createContext<AuthSessionContextType>([null, () => {}])

export const isAuthDepartmentsPayments = (auth?: MaybeAuthSession): boolean => {
  const departmentIds = (auth?.user?.departments || []).map((x) => x.id)
  return departmentIds.includes(DepartmentType.Payments)
}
